<template>
  <a ref="preview" :href="fairground.url" class="map__preview map-preview">
    <div v-if="fairground.image" class="map-preview__image">
      <picture class="map-preview__picture">
        <img :src="fairground.image" :alt="fairground.title" />
      </picture>
    </div>
    <div class="map-preview__content map-preview__content--fairground">
      <div class="map-preview__title">{{ fairground.title }}</div>
      <template v-if="!hideOffers">
        <!-- eslint-disable vue/no-v-html -->
        <div class="map-preview__description" v-html="fairground.teaserDescription"></div>
        <div class="map-preview__detail-page">{{ translateDetail }}</div>
        <google-link :maps="maps" :center="fairground.center"></google-link>
        <!--eslint-enable-->
      </template>
      <template v-else>
        <p class="btn btn--maps">{{ translateDetail }}</p>
      </template>
    </div>
  </a>
</template>

<script>
import GoogleLink from '../components/GoogleLink.vue';

export default {
  name: 'FairgroundPreview',
  components: { GoogleLink },
  props: {
    fairground: {
      type: Object,
      required: true,
    },
    maps: {
      type: String,
      required: true,
    },
    translateDetail: {
      type: String,
      required: true,
    },
    hideOffers: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.preview.removeAttribute('target');
    });
  },
};
</script>
